/**
 * Divider Component
 * 
 * Horizontal divider with optional centered text.
 */

import React from 'react';

export interface DividerProps {
  /** Text to display in the center */
  text?: string;
  /** Background color for the text (to match parent background) */
  bgColor?: string;
  /** Additional CSS classes */
  className?: string;
}

export function Divider({ text, bgColor = 'bg-white', className = '' }: DividerProps) {
  if (!text) {
    return <div className={`w-full border-t border-gray-200 ${className}`} />;
  }

  return (
    <div className={`relative ${className}`}>
      <div className="absolute inset-0 flex items-center">
        <div className="w-full border-t border-gray-200" />
      </div>
      <div className="relative flex justify-center text-sm">
        <span className={`px-3 ${bgColor} text-gray-500`}>{text}</span>
      </div>
    </div>
  );
}

/**
 * SectionDivider Component
 * 
 * Divider for separating sections with uppercase label.
 */
export interface SectionDividerProps {
  /** Label text */
  label: string;
  /** Background color for the label (to match parent background) */
  bgColor?: string;
  /** Additional CSS classes */
  className?: string;
}

export function SectionDivider({ label, bgColor = 'bg-blue-50', className = '' }: SectionDividerProps) {
  return (
    <div className={`relative py-2 ${className}`}>
      <div className="absolute inset-0 flex items-center">
        <div className="w-full border-t border-gray-300" />
      </div>
      <div className="relative flex justify-center">
        <span className={`${bgColor} px-3 text-xs text-gray-500 uppercase tracking-wide`}>
          {label}
        </span>
      </div>
    </div>
  );
}
